"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "code": "SYP",
    "name": {
        "en": "Syrian Pound"
    },
    "type": "national",
    "status": "active",
    "symbol": "SY£",
    "exponent": 2,
    "isoNumeric3Code": "760",
    "isoAlpha3Code": "SYP",
    "nativeSymbol": "ل.س.‏",
    "parentCurrencyMultiplier": 1
};
